<template>
  <div v-if="dataPermission.includes('CNPS_CALENDAR_WK_GROUP_INSERT')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm mới nhóm công việc</h1>
      <div style="float: right">
        <button class="btn btn-light" @click="cancelModal = true">Hủy bỏ</button>
        <button class="btn btn-success btn-primary ml-2" @click="addGroupCalendar">Thêm mới</button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: auto overflow-y: auto">
      <div class="card-body px-20 row">
        <ValidationObserver class="w-100" ref="formAdd">
          <form class="col-md-6" @submit.prevent="addGroupCalendar">
            <ValidationProvider rules="required" vid="service" name="Sản phẩm">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Sản phẩm<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <Select2 v-model="dataInsert.service" :options="optionService"></Select2>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|minMaxName_2" vid="groupName" name="Tên nhóm">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Tên nhóm<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model="dataInsert.groupName" type="text" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|inputLimit50" vid="groupCode" name="Mã nhóm">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Mã nhóm<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model="dataInsert.groupCode" type="text" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="maxReceipt_2" vid="note" name="Mô tả">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label">Mô tả</label>
                <div class="col-sm-8">
                  <input v-model="dataInsert.note" type="text" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required|regexNumber"
              vid="finishTime"
              name="Thời gian hoàn thành"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Thời gian hoàn thành<span style="color: red"> *</span></label
                >
                <div class="col-sm-5">
                  <input v-model="dataInsert.finishTime" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
                <div class="col-sm-3">
                  <b-form-select
                    v-model="dataInsert.finishTimeType"
                    :options="optionTime"
                    size="md"
                  ></b-form-select>
                </div>
              </div>
            </ValidationProvider>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <b-modal id="modal-scoped" v-model="showModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()" v-if="errorAdd"> Đóng </b-button>
        <b-button size="sm" variant="success" @click="backToList" v-else> Đóng </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-scoped" v-model="addModal">
      <template #modal-header="{ close }">
        <h5>Thêm nhóm công việc</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="f18 py-3">Bạn chắc chắn muốn thêm nhóm công việc này ?</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Đóng </b-button>
        <b-button size="sm" variant="primary" @click="confirmAdd"> Xác nhận </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-scoped" v-model="cancelModal">
      <template #modal-header="{ close }">
        <h5>Huỷ thêm nhóm công việc</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="f18 py-3">Bạn chắc chắn muốn huỷ ?</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Đóng </b-button>
        <b-button size="sm" variant="primary" @click="backToList"> Xác nhận </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        dataInsert: {
          finishTimeType: 'MINUTES',
        },
        msgNoti: '',
        iconNoti: '',
        showModal: false,
        optionTime: [
          { value: 'MINUTES', text: 'Phút' },
          { value: 'HOURS', text: 'Giờ' },
          { value: 'DAYS', text: 'Ngày' },
          { value: 'MONTHS', text: 'Tháng' },
        ],
        optionService: [],
        errorAdd: false,
        addModal: false,
        cancelModal: false,
      }
    },
    created() {
      this.getListService()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      // list dịch vụ - sản phẩm
      async getListService() {
        try {
          const data = await SalesManagerService.getGroupService({})
          if (data.success) {
            this.optionService = data.data.groupService
              .map(e => e.detail)
              .flat()
              .map(el => {
                return {
                  id: el.code,
                  text: el.name,
                }
              })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // add nhóm cv
      async addGroupCalendar() {
        const isSuccess = await this.$refs.formAdd.validate()
        if (!isSuccess) {
          return
        }
        this.addModal = true
      },
      async confirmAdd() {
        this.addModal = false
        try {
          const data = await CalendarAfsService.addGroupCalendar(this.dataInsert)
          if (data.success) {
            this.showModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Thêm nhóm công việc thành công'
          } else {
            this.showModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = data.message
            this.errorAdd = true
          }
        } catch (error) {
          console.log(error)
        }
      },
      backToList() {
        this.$router.push('/group-calendar-afs')
      },
    },
  }
</script>
